var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"rotate":270,"size":_vm.circle.size,"width":_vm.circle.width,"value":_vm.progress,"color":"#E57373"}},[_c('div',{staticClass:"text-h6 text-md-h5 font-weight-black"},[_vm._v(_vm._s(_vm.progress)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }